import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import storage from "../../Assets/js/Global";
import { GlobalContext } from "../../Context/GlobalContext";
import { images } from "../../Assets/images";
import { Languages, Check } from "lucide-react";
import "../../Assets/css/Languageselector.css";

const LanguageSelector = () => {
  const {
    setSelected,
    selected,
    setIsManualChange,
    translatedLabels,
    languages,
    getLanguageList,
    logoUrl,
    is4Life,
  } = useContext(GlobalContext);

  const authLabel = translatedLabels?.auth;
  const location = useLocation();
  const isLoggedIn = storage.get("isLoggedIn");
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    storage.set("selectedLanguage", selected);
    setSelected(selected);
  }, [selected, setSelected]);

  useEffect(() => {
    const timer = setTimeout(() => setShowSplash(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    getLanguageList();
  }, [getLanguageList]);

  const companyId = process.env.REACT_APP_COMPANY_ID;
  const fallbackLogo =
    companyId === "wu9zm8"
      ? images.brasilLogo
      : companyId === "8nn29"
        ? images.globalHealthLogo
        : images.appLogo;
  const [logoSrc, setLogoSrc] = useState(fallbackLogo);

  useEffect(() => {
    if (!logoUrl) return;
    const img = new Image();
    img.onload = () => setLogoSrc(logoUrl);
    img.onerror = () => setLogoSrc(fallbackLogo);
    img.src = logoUrl;
  }, [logoUrl]);

  if (showSplash && !isLoggedIn && companyId === "8nn29") {
    return (
      <div className="splash-screen">
        <div className="splash-overlay" />
        <img src={images.initialLogo} alt="App Logo" className="splash-logo" />
      </div>
    );
  }

  return (
    <div className="ls-page content-part">
      <div className={`ls-inner ${isLoggedIn ? "" : "pb-5"}`}>
        {!isLoggedIn && (
          <div className="ls-logo-wrap">
            <img
              src={logoSrc}
              alt="app-logo"
              className="ls-logo"
              style={is4Life ? { width: "190px", height: "80px" } : {}}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = fallbackLogo;
              }}
            />
          </div>
        )}

        <div className="ls-header">
          <div className="ls-header-icon">
            <Languages size={22} />
          </div>
          <div>
            <h4 className="ls-title">
              {authLabel?.choose_your_language?.label_value ||
                "Choose your language"}
            </h4>
            <p className="ls-subtitle">
              {authLabel?.select_your_preferred_language_to_continue
                ?.label_value || "Select your preferred language to continue"}
            </p>
          </div>
        </div>

        <div className="ls-grid">
          {languages?.map((lang, index) => {
            const isSelected = selected === lang.language_code;
            return (
              <div
                key={index}
                className={`ls-card${isSelected ? " ls-card--active" : ""}`}
                onClick={() => {
                  setSelected(lang.language_code);
                  setIsManualChange(true);
                }}
              >
                <div
                  className={`ls-lang-avatar${isSelected ? " ls-lang-avatar--active" : ""}`}
                >
                  {lang.language_translate?.charAt(0) || "?"}
                </div>

                <div className="ls-lang-info">
                  <p className="ls-lang-name">{lang.language_translate}</p>
                  <p className="ls-lang-native">{lang.language_name}</p>
                </div>

                {isSelected ? (
                  <div className="ls-check">
                    <Check size={13} />
                  </div>
                ) : (
                  <div className="ls-radio" />
                )}
              </div>
            );
          })}
        </div>

        {selected && (
          <div className={`ls-continue-wrap`}>
            <Link
              to={isLoggedIn ? "/profile" : "/login"}
              className="btn btn-primary d-flex gap-2 align-items-center justify-content-center"
            >
              {authLabel?.continue?.label_value || "Continue"}
              {/* <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg> */}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSelector;
